export const omitUndefinedFields = (obj) => Object.entries(obj)
    .reduce((acc, [key, value]) => (
        value === undefined ? acc : {...acc, [key]: value}
    ), {});

export const omitUndefinedAndNullFields = (obj) => Object.entries(obj)
    .reduce((acc, [key, value]) => (
        value === undefined || value === null ? acc : {...acc, [key]: value}
    ), {});
